module.exports = __webpack_public_path__ + "img/SE5164037086.6ee80f4f.svg";